export default __webpack_public_path__ + "media/images/rapport-rouge-feb9aa1d9df3bf8db60ae8cb237862f0.png";